export const translations = {
    de: {
      hatemHamzaoui: 'Hatem Hamzaoui',
      hatemHamzaouiDesc1: 'Geschäftsführer und Gesellschafter der novobit group GmbH Geschäftsführer der Novobit Partners Sarl',
      hatemHamzaouiDesc2: "   Als studierter Informatiker sammelte Hatem im Laufe der Zeit vielfältige Erfahrungen in der IT-Branche. So entwickelte er nicht nur Software,\n" +
          " sondern auch Software-Unternehmen und deren Zukunft. Im August 2015 gründete Hatem die novobit und baut das Unternehmen seitdem mit innovativen zukunftsweisenden Themen kontinuierlich aus.\n",

      novobitInDubai: "novobit Dubai",
      novobitInDubaiDesc1: " " +
          "Nach unserem Hauptsitz in Braunschweig und unserer Niederlassung in Tunis ist Dubai in den Vereinigten Arabischen Emiraten der dritte\n" +
          "novobit Standort."  ,
      novobitInDubaiDesc2: "Hier, in der etwas südlich vom Stadtzentrum gelegenen Dubai Internet City, sind wir mit KI-Dienstleistungen, Account Management und Vertrieb für die Region Middle East am Start.",

      startUpDubaiTeam: "Unser Start-Up team\n in Dubai\n",
      startUpDubaiTeamDesc1: "von links nach rechts:\n",
      startUpDubaiTeamDesc2Hatem: "Geschäftsführer",
      startUpDubaiTeamDesc2Jean: "Jean Fideli",
      startUpDubaiTeamDesc2Jean2: "Business Development\n Manager\n",
      AndreasSimon: "Andreas Simon",
      AndreasSimonDesc: "Sales Manager",
      EliasHamzaoui: "Elias Hamzaoui",
      EliasHamzaouiDesc: "Account Manager",
      informationsSicherhet:"INFORMATIONSSICHERHEIT\n BEI NOVOBIT\n",
      informationsSicherhetDesc1:"An unseren Standorten in Braunschweig und Tunis liegt\n" +
          "eine Bewertung nach TISAX® vor, einem Sicherheitsstandard\n" +
          "basierend auf ISO 27001.\n",
      informationsSicherhetDesc2:"TISAX® ist eine eingetragene Marke der ENX-Association. Die novobit group GmbH steht im Rahmen dieser Angebote in keiner geschäftlichen Beziehung zur ENX und bietet auch Beratungen zu den Anforderungskatalogen anderer Anbieter an. Mit der Nennung der Marke TISAX® ist keine Aussage des Markeninhabers zu den hier beworbenen Leistungen verbunden.",
      IngoRübel: "Ingo Rübel",
      IngoRübelDesc1: "Abteilungsleitung",
      IngoRübelDesc2: "Software-Projekte I",
      UnserKILAB: "UNSER KI-LAB GRÜNDUNGSTEAM\n",
      UnserKILABDesc: "2023 haben wir am Standort Braunschweig eine eigene Abteilung für Künstliche Intelligenz ins Leben gerufen. Was mit Prof. Dr. Ramzi Guetari als AI Program Director und einer Handvoll junger Talente begann, hat sich seitdem kontinuierlich weiterentwickelt – zu einer zweiten Unternehmenssäule bei novobit.",
      NadaHamzaoui: "Nada Hamzaoui",
      NadaHamzaouiDesc1: "Abteilungsleitung ",
      NadaHamzaouiDesc2: "Software-Projekte II",
      ProfRamziGuirati: "Prof. Dr. Ramzi Guetari",
      ProfRamziGuiratiDesc: "KI-Programmdirektor ",


      about: 'Über uns',
      software: 'Software Dienstleistungen',
      ai: 'KI-Expertise',
      academy: 'Akademie',
      career: 'Karriere',
      contact: 'Kontakt',
      getInspired: 'Get inspired',
      welcome: 'Willkommen bei novobit, einer IT-Company mit Hauptsitz in Braunschweig und weiteren Standorten in Tunis und Dubai.',
      news: 'NOVOBIT AKTUELL',
      PodcastbeiNIEDERSACHSEN:'Podcast bei Niedersachsen.next',
      NewsletterDescPicture:"„Newsletter“",
      newsLetterMagazine: 'Zum IHK-Magazin',
      GERMANEMIRATES:'Vortrag beim German Emirates Club, Dubai'  ,
      DOAG_Tourbus:"KI NAVIGATOR ROADSHOW"  ,
      DOAG_TourbusDesc1:"novobit wurde gebeten, den Impulsvortrag im DOAG TOURBUS für den Tourstopp Braunschweig zu halten."  ,
      DOAG_TourbusDesc2:"Mohamed Omar Bouchkati und Fourat Ben Driaa referierten zum Thema AI-DRIVEN SOFTWARE DEVELOPMENT und gaben einen Überblick über den aktuellen Stand der Al-Tools und ihre Automationsgrade. Highlight des Abends war die Live-Vorführung eines bislang unveröffentlichten Level-4-Tools - ein Ausblick in die nahe Zukunft, der für Überraschung und Begeisterung sorgte. Es handelte sich um eine Eigenentwicklung aus unserem Kl-Lab. Als die Anwesenden erfuhren, dass beide Speaker persönlich an der Entwicklung beteiligt waren, entstand eine lebendige Fragerunde, bei der munter gefachsimpelt wurde."  ,
      novobit_Braunschweig: "novobit Hauptsitz in Braunschweig,",
      novobit_BraunschweigDesc1: "Dachterrasse mit Panoramablick über die Stadt.",
      novobit_BraunschweigDesc2: "Braunschweig ist das Zentrum der norddeutschen Metropolregion für Ingenieurswesen mit der Technischen Universität, dem Hauptsitz von Volkswagen und Institutionen wie dem Deutschen Zentrum für Luft- und Raumfahrttechnik.",
      novobit_IN_Braunschweig: "novobit in Braunschweig,",
      novobit_IN_BraunschweigDesc1: "im Valentin-Klein-Haus in der Theodor-Heuss-Straße 2.",
      novobit_IN_BraunschweigDesc2:  "Zentral gelegen am Bürgerpark und gut erreichbar über die Autobahnabfahrt Braunschweig-Gartenstadt.",


      DOAG_Tourbus_picture:'../../assets/Pictures/DOAG_Tourbus.jpg'  ,
      OfficePicture: '../../assets/_Mouse-over/Braunschweig_Dachterrasse.png',
      DOAG_Tourbus_picture_hover:'../../assets/_Mouse-over/DOAG_Tourbus_de.png'  ,
      Braunschweig_Entrance_Picture: '../../assets/_Mouse-over/Braunschweig_Eingang.png',
      TeamDubai_Picture: '../../assets/_Mouse-over/Team_in-Dubai_ger - Copy.png',
      ReferencePicture: '../../assets/_Mouse-over/Referenzen_de.jpg'  ,
      pdfUrlNewsLetter: '/newsletter_25_1.pdf',
      experience: 'Wir verbinden 30 Jahre Erfahrung in Software-Entwicklung mit zukunftsweisendem Know-how im Bereich Künstliche Intelligenz.',
      efficiency: 'Auf diese Weise entwickeln wir nicht nur Software, sondern vor allem auch Menschen und Unternehmen, Prozesse und Produkte, Ideen und Visionen und vor allem auch etwas ganz Entscheidendes – Effizienz.',
      careerBraunschweig: 'Karriere in Braunschweig',
      careerTunis: 'Karriere in Tunis',
      niceViews: 'Schöne Aussichten',
      jobsBraunschweig: 'JOBS IN BRAUNSCHWEIG',
      jobsTunis: 'JOBS IN TUNIS',
      softwareDev: 'SOFTWARE-ENTWICKLER (M/W/D)',
      fullstack: 'FULL-STACK-ENTWICKLER JAVA (M/W/D)',
      initiative: 'INITIATIVBEWERBUNG (M/W/D)',
      forStudents: 'AUCH FÜR STUDIENABBRECHER',
      about_1_1: "../../assets/Pictures/Brunis_Braunschweig_und_Tunis_novobit.jpg",
      about_1_2: "../../assets/Pictures/Brunis_PopUp_d.png" ,
      about_2_1: "../../assets/Pictures/DevOps-Kultur_novobit.png" ,
      about_2_2: "../../assets/_Pop-ups/novobit_Historie_ge.png",
      about_3: "../../assets/_Mouse-over/Hatem_Hamzaoui_Managing_Director.png",
      about_4: "../../assets/_Mouse-over/novobit_dubai_Vertrieb.png",
      softwareservices_1_1: "../../assets/Pictures/Portfolio_novobit_Software-Entwicklung.jpg",
      softwareservices_1_2: "../../assets/_Pop-ups/DevOps_Leistungen.png",
      lifeCycle_1_2: "../../assets/_Pop-ups/novobit_Projektablauf.png",
      softwareservices_2_1: "../../assets/Pictures/Software_Entwicklung_Process_User_Story_Life_Cycle.jpg",
      softwareservices_2_2: "../../assets/_Pop-ups/KI_Expertise_novobit_Beratung.png",
      softwareservices_3: "../../assets/_Mouse-over/Ingo_Ruebel_Software-Projekte_1.png",
      softwareservices_4: "../../assets/_Mouse-over/Nada_Hamzaoui_Ansprechpartnerin_Tunis-ge.png",
      softwareservices_5: "../../assets/_Pop-ups/Planungssoftware_serielle_Fertigung.png",
      softwareservices_6: "../../assets/_Pop-ups/Planungssoftware_Reporting_Tool_ge.png",
      softwareservices_7: "../../assets/_Mouse-over/Informationssicherheit_novobit_ge.png",
      downloadPdf: "PDF herunterladen",
      softwareservices_8: "../../assets/_Pop-ups/digitale_Signage-Systeme.png",
      ki_expert_1_1: "../../assets/Pictures/AI-Lab_novobit_Know-how.jpg",
      ki_expert_1_2: "../../assets/_Pop-ups/KI_Expertise_novobit_Beratung.png",
      ki_expert_2: "../../assets/_Mouse-over/novobit_KI-Lab_Gruendungsteam.png",
      ki_expert_3: "../../assets/_Pop-ups/KI_Expertise_novobit_smartmaps.png",
      ki_expert_4: "../../assets/_Mouse-over/Ramzi_Guetari_KI-Programmdirektor.png",
      ki_expert_5: "../../assets/_Pop-ups/KI_Expertise_novobit_smartfake.png",
      ki_expert_6_1: "../../assets/Pictures/Visionen_novobit_ge_new.jpg",
      ki_expert_6_2: "../../assets/_Pop-ups/KI_Expertise_ogi.png",
      ki_expert_7: "../../assets/_Pop-ups/KI_Produktentwicklung_devally.png",
      academy_1: "../../assets/Pictures/Akademie_KI-Entwickler.jpg",
      academy_2: "../../assets/_Pop-ups/Akademie_novobit.jpg",
      career_1_1: "../../assets/Pictures/Braunschweig_Panorama_Aussicht.jpg",
      career_1_1_2: "../../assets/_Pop-ups/novobit_Benefits_Braunschweig.png",
      career_1_2: "../../assets/_Pop-ups/novobit_Benefits_Tunis.png",
      career_2: "../../assets/_Pop-ups/novobit_Bewerbungsprozess_ge.png",
      career_3_1: "../../assets/Pictures/novobit_Jobs_Braunschweig.png",
      career_3_2: "../../assets/_Pop-ups/novobit_Jobs_in_Braunschweig_Liste-ge.png",
      career_4_1: "../../assets/Pictures/Tunis_Panorama_Aussicht.jpg",
      career_4_2: "../../assets/_Pop-ups/novobit_Benefits_Tunis.png",
      career_5: "../../assets/_Pop-ups/novobit_Bewerbungsprozess_Tunis_ge.png",
      career_6_1: "../../assets/Pictures/novobit_Jobs_Tunis.png",
      career_6_2: "../../assets/_Pop-ups/novobit_Jobs_in_Tunis_Liste_ge.png",
      career_PDF: '/NG_FO_Stellenausschreibung_DEU.pdf',
      Softwareentwickler: 'Softwareentwickler (m/f/d)',
      contact_1: "../../assets/_Pop-ups/novobit_Contacts_ger.png",
      contact_1_2: "../../assets/Pictures/novobit_Kontakt_ge.jpg",
      conatct_2: "../../assets/_Pop-ups/novobit_Kontakte.png",
      ClickLearnMore: "Erfahre mehr"
    },
    en: {
      hatemHamzaoui: 'Hatem Hamzaoui',
      hatemHamzaouiDesc1: 'Managing Director and shareholder of novobit group GmbH Managing Director of Novobit Partners Sarl\n',
      hatemHamzaouiDesc2: "As a graduate computer scientist, Hatem has gained a wide range of experience in the IT industry over the years. He not only developed software, but also software companies and their future. Hatem founded novobit in August 2015 and has been continuously expanding the ycompany with innovative, forward-looking topics ever since.",
      novobitInDubai: "novobit Dubai",
      novobitInDubaiDesc1: "After our headquarters in Braunschweig (Germany) and our branch in Tunis, Dubai in the United Arab Emirates is the third\n" +
          "novobit location." ,
      novobitInDubaiDesc2: "Here, in Dubai Internet City, located just south of the city center, we provide AI services, account management and sales for\n" +
          "the Middle East region.",
      startUpDubaiTeam: "Our start-up team\n in Dubai\n",
      startUpDubaiTeamDesc1: "from left to right:",
      startUpDubaiTeamDesc2Hatem: "Managing Director",
      startUpDubaiTeamDesc2Jean: "Jean Fideli",
      startUpDubaiTeamDesc2Jean2: "Business Development\n Manager\n",
      AndreasSimon: "Andreas Simon",
      AndreasSimonDesc: "Sales Manager",
      EliasHamzaoui: "Elias Hamzaoui",
      EliasHamzaouiDesc: "Account Manager",
      informationsSicherhet:"INFORMATION SECURITY \n AT NOVOBIT\n",
      informationsSicherhetDesc1:"Our locations in Braunschweig and Tunis have been assessed in accordance with TISAX®, \n" +
          "a security standard based on ISO 27001.\n",
      informationsSicherhetDesc2:"*TISAX® is a registered trademark of the ENX Association. The novobit group GmbH has no business relationship with ENX in the context of these offers and also offers consulting services for the requirements catalogs of other providers. The naming of the TISAX® brand does not imply any statement by the brand owner regarding the services advertised here.",
      IngoRübel: "Ingo Rübel",
      IngoRübelDesc1: "Department management",
      IngoRübelDesc2: "Software Projects I",
      UnserKILAB: "OUR AI-LAB FOUNDING TEAM",
      UnserKILABDesc: "In 2023, we set up our own department for artificial intelligence at our headquarters in Braunschweig. What began with Prof. Dr Ramzi Guetari as AI Program Director and a handful of young talents has developed continuously since then – into a second pillar of novobit.",
      NadaHamzaoui: "Nada Hamzaoui",
      NadaHamzaouiDesc1: "Department management ",
      NadaHamzaouiDesc2: "Software Projects II",
      ProfRamziGuirati: "Prof. Dr. Ramzi Guetari",
      ProfRamziGuiratiDesc: "AI Program Director ",

      about: 'About us',
      software: 'Software Services',
      ai: 'AI Expertise',
      academy: 'Academy',
      career: 'Career',
      contact: 'Contact',
      getInspired: 'Get inspired',
      welcome: 'Welcome to novobit, an IT company headquartered in Braunschweig, with additional locations in Tunis and Dubai.',
      news: 'NOVOBIT NEWS',
      PodcastbeiNIEDERSACHSEN:"Podcast on Niedersachsen.next.",
      NewsletterDescPicture:"Newsletter 01|25",
      newsLetterMagazine: 'To the IHK magazine',
      GERMANEMIRATES:'Lecture at the German Emirates Club, Dubai'  ,
      DOAG_Tourbus:"KI NAVIGATOR ROADSHOW"  ,
      DOAG_TourbusDesc1:"For the tour stop in Braunschweig, novobit was asked to carry out the presentation in the DOAG TOURBUS."  ,
      DOAG_TourbusDesc2:"Mohamed Omar Bouchkati and Fourat Ben Driaa spoke on the topic of AI-DRIVEN SOFTWARE DEVELOPMENT and gave an overview of the current status of Al tools and their levels of automation. The highlight of the evening was the live demonstration of a previously unreleased Level 4 tool - a glimpse into the near future that caused surprise and excite- ment. It was an in-house development from our Al Lab. When the atten- dees learned that both speakers were personally involved in the develop- ment, a lively Q&A session ensued, with everyone talking shop."  ,
      novobit_Braunschweig: "novobit headquarters in Braunschweig,",
      novobit_BraunschweigDesc1: "roof terrace with panoramic view over the city.",
      novobit_BraunschweigDesc2:  "Braunschweig is the center of the northern German metropolitan region for engineering with the Technical University, the headquarters of Volkswagen and institutions such as the German Aerospace Center.",
      novobit_IN_Braunschweig: "novobit in Braunschweig,",
      novobit_IN_BraunschweigDesc1: "in the Valentin-Klein-Haus at Theodor-Heuss-Straße 2.",
      novobit_IN_BraunschweigDesc2: "Centrally located at Bürgerpark and easily accessible via the Braunschweig-Gartenstadt highway exit.",

      DOAG_Tourbus_picture:'../../assets/Pictures/DOAG_Tourbus.jpg'  ,
      OfficePicture: '../../assets/_Mouse-over/Braunschweig_roof_terrasse.png',
      DOAG_Tourbus_picture_hover:'../../assets/_Mouse-over/DOAG_Tourbus_en.png'  , 
      Braunschweig_Entrance_Picture: '../../assets/_Mouse-over/Braunschweig_Entrance.png',
      TeamDubai_Picture: '../../assets/_Mouse-over/Team_in-Dubai_en.png',
      ReferencePicture: '../../assets/_Mouse-over/References_en.jpg'  ,
      pdfUrlNewsLetter: '/newsletter_25_1_en.pdf',
      experience: 'We combine 30 years of software development experience with forward-thinking expertise in artificial intelligence.',
      efficiency: 'In this way, we develop not only software, but above all people and companies, processes and products, ideas and visions, and most importantly, something crucial - efficiency.',
      careerBraunschweig: 'Career in Braunschweig',
      careerTunis: 'Career in Tunis',
      niceViews: 'Nice Views',
      jobsBraunschweig: 'JOBS IN BRAUNSCHWEIG',
      jobsTunis: 'JOBS IN TUNIS',
      softwareDev: 'SOFTWARE DEVELOPER (M/F/D)',
      fullstack: 'FULL-STACK DEVELOPER JAVA (M/F/D)',
      initiative: 'INITIATIVE APPLICATION (M/F/D)',
      forStudents: 'ALSO FOR UNIVERSITY DROPOUTS',
      about_1_1: "../../assets/Pictures/Brunis_Braunschweig_and_Tunis_novobit.jpg",
      about_1_2: "../../assets/Pictures/Brunis_PopUp_d.png" ,
      about_2_1: "../../assets/Pictures/DevOps-Kultur_novobit.png" ,
      about_2_2: "../../assets/_Pop-ups/novobit_History_en.png",
      about_3: "../../assets/_Mouse-over/Hatem_Hamzaoui_Geschaeftsfuehrer.png",
      about_4: "../../assets/_Mouse-over/novobit_dubai_Sales.png",
      softwareservices_1_1: "../../assets/Pictures/Portfolio_novobit_Software-Entwicklung_EN.jpg",
      softwareservices_1_2: "../../assets/_Pop-ups/DevOps_Leistungen_EN.png",
      lifeCycle_1_2: "../../assets/_Pop-ups/novobit_Projektablauf_en.png",
      softwareservices_2_1: "../../assets/Pictures/Software_Entwicklung_Process_User_Story_Life_Cycle.jpg",
      softwareservices_2_2: "../../assets/_Pop-ups/AI_Expertise_novobit_Consulting.png",
      softwareservices_3: "../../assets/_Mouse-over/Ingo_Ruebel_Software-Projekte_en.png",
      softwareservices_4: "../../assets/_Mouse-over/Nada_Hamzaoui_Software_Projects_2.png",
      softwareservices_5: "../../assets/_Pop-ups/Planning_software_serial_production.png",
      softwareservices_6: "../../assets/_Pop-ups/Planungssoftware_Reporting_Tool_en.png",
      softwareservices_7: "../../assets/_Mouse-over/Information_Secutity_novobit_en.png",
      downloadPdf: "Download PDF",
      softwareservices_8: "../../assets/_Pop-ups/digital_Signage-Systems.png",
      ki_expert_1_1: "../../assets/Pictures/AI-Lab_novobit_Know_how.jpg",
      ki_expert_1_2: "../../assets/_Pop-ups/KI_Expertise_novobit_Beratung.png",
      ki_expert_2: "../../assets/_Mouse-over/novobit_AI_Lab_Founding_Team.png",
      ki_expert_3: "../../assets/_Pop-ups/AI_Expertise_novobit_smartmaps.png",
      ki_expert_4: "../../assets/_Mouse-over/Ramzi_Guetari_AI_Program_Director.png",
      ki_expert_5: "../../assets/_Pop-ups/KI_Expertise_novobit_smartfake_en.png",     
      
      ki_expert_6_1: "../../assets/Pictures/Visions_novobit_en.jpg",
      ki_expert_6_2: "../../assets/_Pop-ups/AI_Expertise_novobit.png",
      ki_expert_7: "../../assets/_Pop-ups/AI_Product_development_devally.png",
      academy_1: "../../assets/Pictures/Academy_AI_Developer_novobit.jpg",
      academy_2: "../../assets/_Pop-ups/Academy_novobit.jpg",
      career_1_1: "../../assets/Pictures/Braunschweig_Panorama_Prospects.jpg",
      career_1_1_2: "../../assets/_Pop-ups/novobit_Benefits_employees_Braunschweig.png",
      career_1_2: "../../assets/_Pop-ups/novobit_Benefits_employees_Tunis_en.png",
      career_2: "../../assets/_Pop-ups/novobit_Bewerbungsprozess_en.png",
      career_3_1: "../../assets/Pictures/novobit_Jobs_Braunschweig.png",
      career_3_2: "../../assets/_Pop-ups/novobit_Jobs_in_Brunswick_List_en.png",
      career_4_1: "../../assets/Pictures/Tunis_Panorama_Aussicht_en.jpg",
      career_4_2: "../../assets/_Pop-ups/novobit_Benefits_Tunis.png",
      career_5: "../../assets/_Pop-ups/novobit_Application_Process_Tunis_eng.png",
      career_6_1: "../../assets/Pictures/novobit_Jobs_Tunis.png",
      career_6_2: "../../assets/_Pop-ups/novobit_Jobs_in_Tunis_List_en.png",
      career_PDF: '/NG_FO_Stellenausschreibung_Softwareentwickler_ENG.pdf',
      Softwareentwickler: 'Software Developer (m/f/d)',
      contact_1: "../../assets/_Pop-ups/novobit_Contacts_en.png",
      contact_1_2: "../../assets/Pictures/Contact_novobit.jpg",
      conatct_2: "../../assets/_Pop-ups/novobit_Kontakte.png"  ,
      ClickLearnMore: "Click to learn more"
    },
    ar: {
      hatemHamzaoui: 'Hatem Hamzaoui',
      hatemHamzaouiDesc1: 'Managing Director and shareholder of novobit group GmbH\n' +
          'Managing Director of Novobit Partners Sarl',
      hatemHamzaouiDesc2: 'As a graduate computer scientist, Hatem has gained a wide range\n' +
          'of experience in the IT industry over the years. He not only developed\n' +
          'software, but also software companies and their future. Hatem\n' +
          'founded novobit in August 2015 and has been continuously expanding\n' +
          'the ycompany with innovative, forward-looking topics ever since',
      about: 'من نحن',
      software: 'خدمات البرمجيات',
      ai: 'خبرة الذكاء الاصطناعي',
      academy: 'الأكاديمية',
      career: 'الوظائف',
      contact: 'اتصل بنا',
      getInspired: 'كن ملهماً',
      welcome: 'مرحباً بكم في نوفوبت، شركة تكنولوجيا المعلومات التي يقع مقرها الرئيسي في براونشفايغ ولديها موقع ثانٍ في تونس.',
      news: 'أخبار نوفوبت',
      PodcastbeiNIEDERSACHSEN:'بودكاست في نيدرساكسن',
      NewsletterDescPicture:"النشرة الإخبارية",
      newsLetterMagazine: 'Zum IHK-Magazin',
      GERMANEMIRATES:'محاضرة في النادي الألماني الإماراتي، دبي'  ,
      DOAG_Tourbus:"KI NAVIGATOR ROADSHOW"  ,
      DOAG_TourbusDesc1:"novobit wurde gebeten, den Impulsvortrag im DOAG TOURBUS für den Tourstopp Braunschweig zu halten."  ,
      DOAG_TourbusDesc2:"Mohamed Omar Bouchkati und Fourat Ben Driaa referierten zum Thema AI-DRIVEN SOFTWARE DEVELOPMENT und gaben einen Überblick über den aktuellen Stand der Al-Tools und ihre Automationsgrade. Highlight des Abends war die Live-Vorführung eines bislang unveröffentlichten Level-4-Tools - ein Ausblick in die nahe Zukunft, der für Überraschung und Begeisterung sorgte. Es handelte sich um eine Eigenentwicklung aus unserem Kl-Lab. Als die Anwesenden erfuhren, dass beide Speaker persönlich an der Entwicklung beteiligt waren, entstand eine lebendige Fragerunde, bei der munter gefachsimpelt wurde."  ,
      novobit_Braunschweig: "novobit Hauptsitz in Braunschweig,",
      novobit_BraunschweigDesc1: "Dachterrasse mit Panoramablick über die Stadt.",
      novobit_BraunschweigDesc2: "Braunschweig ist das Zentrum der norddeutschen Metropolregion für Ingenieurswesen mit der Technischen Universität, dem Hauptsitz von Volkswagen und Institutionen wie dem Deutschen Zentrum für Luft- und Raumfahrttechnik.",


      DOAG_Tourbus_picture:'../../assets/Pictures/DOAG_Tourbus.jpg'  ,
      OfficePicture: '../../assets/_Mouse-over/Braunschweig_Dachterrasse.png',
      DOAG_Tourbus_picture_hover:'../../assets/_Mouse-over/DOAG_Tourbus_de.png'  ,
      Braunschweig_Entrance_Picture: '../../assets/_Mouse-over/Braunschweig_Eingang.png',
      TeamDubai_Picture: '../../assets/_Mouse-over/Team_in-Dubai_ger.png',
      ReferencePicture: '../../assets/_Mouse-over/Referenzen_de.jpg'  ,
      pdfUrlNewsLetter: '/newsletter_25_1.pdf',
      experience: 'نجمع بين 30 عاماً من الخبرة في تطوير البرمجيات مع خبرة مستقبلية في مجال الذكاء الاصطناعي.',
      efficiency: 'بهذه الطريقة، نحن نطور ليس فقط البرمجيات، ولكن قبل كل شيء الأشخاص والشركات والعمليات والمنتجات والأفكار والرؤى، والأهم من ذلك، شيئاً حاسماً - الكفاءة.',
      careerBraunschweig: 'الوظائف في براونشفايغ',
      careerTunis: 'الوظائف في تونس',
      niceViews: 'مناظر جميلة',
      jobsBraunschweig: 'الوظائف في براونشفايغ',
      jobsTunis: 'الوظائف في تونس',
      softwareDev: 'مطور برمجيات (ذكر/أنثى)',
      fullstack: 'مطور فول ستاك جافا (ذكر/أنثى)',
      initiative: 'تقديم مبادرة (ذكر/أنثى)',
      forStudents: 'متاح أيضاً للطلاب المتوقفين عن الدراسة',
      about_1_1: "../../assets/Pictures/Brunis_Braunschweig_and_Tunis_novobit.jpg",
      about_1_2: "../../assets/Pictures/Brunis_PopUp_d.png" ,
      about_2_1: "../../assets/Pictures/DevOps-Kultur_novobit.png" ,
      about_2_2: "../../assets/_Pop-ups/Historie_novobit.png",
      about_3: "../../assets/_Mouse-over/Hatem_Hamzaoui_Managing_Director.png",
      about_4: "../../assets/_Mouse-over/novobit_dubai_Vertrieb.png",
      softwareservices_1_1: "../../assets/Pictures/Portfolio_novobit_Software-Entwicklung.jpg",
      softwareservices_1_2: "../../assets/_Pop-ups/DevOps_Leistungen.png",
      lifeCycle_1_2: "../../assets/_Pop-ups/novobit_Projektablauf.png",
      softwareservices_2_1: "../../assets/Pictures/Software_Entwicklung_Process_User_Story_Life_Cycle.jpg",
      softwareservices_2_2: "../../assets/_Pop-ups/KI_Expertise_novobit_Beratung.png",
      softwareservices_3: "../../assets/_Mouse-over/Ingo_Ruebel_Software-Projekte_1.png",
      softwareservices_4: "../../assets/_Mouse-over/Nada_Hamzaoui_Ansprechpartnerin_Tunis.png",
      softwareservices_5: "../../assets/_Pop-ups/Planungssoftware_serielle_Fertigung.png",
      softwareservices_6: "../../assets/_Pop-ups/Planungssoftware_Reporting_Tool_en.png",
      softwareservices_7: "../../assets/_Mouse-over/Informationssicherheit_novobit.png",
      downloadPdf: "PDF herunterladen",
      softwareservices_8: "../../assets/_Pop-ups/digitale_Signage-Systeme.png",
      ki_expert_1_1: "../../assets/Pictures/AI-Lab_novobit_Know-how.jpg",
      ki_expert_1_2: "../../assets/_Pop-ups/KI_Expertise_novobit_Beratung.png",
      ki_expert_2: "../../assets/_Mouse-over/novobit_KI-Lab_Gruendungsteam.png",
      ki_expert_3: "../../assets/_Pop-ups/KI_Expertise_novobit_smartmaps.png",
      ki_expert_4: "../../assets/_Mouse-over/Ramzi_Guetari_KI-Programmdirektor.png",
      ki_expert_5: "../../assets/_Pop-ups/KI_Expertise_novobit_smartfake.png",
      ki_expert_6_1: "../../assets/Pictures/Visions_novobit.jpg",
      ki_expert_6_2: "../../assets/_Pop-ups/KI_Expertise_ogi.png",
      ki_expert_7: "../../assets/_Pop-ups/novobit_Produktentwicklung_devally.png",
      academy_1: "../../assets/Pictures/Akademie_KI-Entwickler.jpg",
      academy_2: "../../assets/_Pop-ups/Akademie_novobit.jpg",
      career_1_1: "../../assets/Pictures/Braunschweig_Panorama_Aussicht.jpg",
      career_1_1_2: "../../assets/_Pop-ups/novobit_Benefits_Braunschweig.png",
      career_1_2: "../../assets/_Pop-ups/novobit_Benefits_Tunis.png",
      career_2: "../../assets/_Pop-ups/novobit_Bewerbungsprozess.png",
      career_3_1: "../../assets/Pictures/novobit_Jobs_Braunschweig.png",
      career_3_2: "../../assets/_Pop-ups/novobit_Jobs_in_Brunswick_List_en.png",
      career_4_1: "../../assets/Pictures/Tunis_Panorama_Aussicht.jpg",
      career_4_2: "../../assets/_Pop-ups/novobit_Benefits_Tunis.png",
      career_5: "../../assets/_Pop-ups/novobit_Bewerbungsprozess_Tunis.png",
      career_6_1: "../../assets/Pictures/novobit_Jobs_Tunis.png",
      career_6_2: "../../assets/_Pop-ups/novobit_Jobs_in_Tunis_Liste.png",
      career_PDF: '/NG_FO_Stellenausschreibung_DEU.pdf',
      Softwareentwickler: 'Softwareentwickler (m/f/d)',
      contact_1: "../../assets/_Pop-ups/novobit_Contacts.png",
      contact_1_2: "../../assets/Pictures/novobit_Kontakt_ge.jpg",
      conatct_2: "../../assets/_Pop-ups/novobit_Kontakte.png" ,
      ClickLearnMore: "انقر لمعرفة المزيد"
    }
  } as const;
